import React from 'react';
// import ReactDOM from 'react-dom';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  TextField,
  Paper,
  withStyles,
  Button,
  FormHelperText,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
  InputAdornment,
  Divider,
  InputLabel,
  NativeSelect,
  OutlinedInput,
  MenuItem,
  Select,
} from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
import Loader from '../../components/Loader/LoaderView';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';
import { tenantInfo } from '../../utils/tenantInformation';

const errRequired = 'required_field';
const errInvalidField = 'this_field_is_invalid';
const bloodGroupList = ['A', 'B', 'AB', 'O'];
const relationshipList = ['couple', 'children', 'relative', 'other'];

class PatientsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
    // this.initData = this.initData;
    this.state = {
      tenants: [],
      data: {
        tenantId: null,
        firstname: '',
        lastname: '',
        firstnameEn: '',
        lastnameEn: '',
        hn: '',
        dob: '',
        weight: '',
        height: '',
        gender: 'M',
        contactFirstname: '',
        contactLastname: '',
        contactPhone: '',
        bloodGroup: '',
        contactRelationship: '',
      },
      errorField: {
        tenantId: {
          flag: false,
          msg: '',
        },
        firstname: {
          flag: false,
          msg: '',
        },
        lastname: {
          flag: false,
          msg: '',
        },
        firstnameEn: {
          flag: false,
          msg: '',
        },
        lastnameEn: {
          flag: false,
          msg: '',
        },
        hn: {
          flag: false,
          msg: '',
        },
        dob: {
          flag: false,
          msg: '',
        },
        gender: {
          flag: false,
          msg: '',
        },
        contactFirstname: {
          flag: false,
          msg: '',
        },
        contactLastname: {
          flag: false,
          msg: '',
        },
        contactPhone: {
          flag: false,
          msg: '',
        },
        contactRelationship: {
          flag: false,
          msg: '',
        },
      },
      labelGroupWidth: 0,
    };
  }

  async componentDidMount() {
    const tenants = tenantInfo();
    this.setState({ tenants });

    const { offset, limit, search, sort, order, tenantIds } = this.props.patient.toJS();
    await this.props.patient.getPatient(offset, limit, search, sort, order, tenantIds);
    this.props.contactperson.setData([]);

    this.initData();
  }

  goBack() {
    this.props.patient.setAction('action', true);
    this.props.history.goBack();
  }

  async initData() {
    const { patientList, tenantIds } = this.props.patient.toJS();
    const { id } = this.props.match.params;
    const patientId = Number(id);
    const showData = patientList.data.find((item) => item.id === patientId);
    if (showData) {
      const contactPersons = await this.props.contactperson.findContactPersonByPatientId(patientId);
      this.props.contactperson.setData(contactPersons);
      this.setState({
        data: {
          id: showData.id,
          tenantId: showData.tenantId,
          firstname: showData.firstname,
          lastname: showData.lastname,
          firstnameEn: showData.firstnameEn,
          lastnameEn: showData.lastnameEn,
          hn: showData.hn,
          dob: showData.dob,
          gender: showData.gender,
          status: showData.status,
          weight: showData.weight,
          height: showData.height,
          bloodGroup: showData.bloodGroup,
        },
      });
    } else {
      const tenants = tenantInfo();
      if (tenants.length === 1) {
        tenants.forEach((g) => {
          this.setState({ data: { tenantId: g.id } });
        });
      } else if (tenantIds && tenantIds.length === 1) {
        tenantIds.forEach((id) => {
          this.setState({ data: { tenantId: id } });
        });
      }
    }
  }

  handleChange = (e) => {
    let { name, value } = e.target;
    this.clearErrorField(name);
    this.setState({ data: { ...this.state.data, [name]: value } });
  };

  onTextChange = (key, e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.props.contactperson.changeData(key, value);
  };

  validateInputChange = (e) => {
    let { name, value } = e.target;
    let flag = true;
    if (value) {
      const patt = /^[0-9]+((\.)?)+([0-9]{1,2})?$/;
      flag = patt.test(value);
    }

    if (flag) {
      this.setState({ data: { ...this.state.data, [name]: value } });
      // this.setState((prevState) => {
      //   prevState.data[name] = value
      //   return prevState;
      // });
    }
  };

  onSubmitFormPatient(data) {
    const path = this.props.match.path.replace('/app/patients/:id/', '');
    if (this.validate()) {
      path === 'edit' ? this.handleEditPatient(data) : this.handleCreatePatient(data);
    }
  }

  handleCreatePatient = async (data) => {
    const { t } = this.props;
    try {
      const result = await this.props.patient.patientCreate(data);
      if (result.statusCode === 200) {
        await this.props.contactperson.create(this.props.contactperson.data, result.body.id);
        Swal.fire({ html: `<h4>${t('create_success')}`, type: 'success' }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            this.props.history.push('../patients');
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
          }
        });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        // Swal.fire({ html: `<h4>${e.error.message}`, type: "error" , showConfirmButton: false});
        clearLocalStorage();
        window.location.href = '/login';
      } else if (e.statusCode === 400) {
        const msg = e.error.message || t('failed_to_create');
        Swal.fire({ html: `<h4>${msg}`, type: 'error' });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
      }
    }
  };

  handleEditPatient = async (data) => {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('edit_patient')}?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: `${t('edit')}`,
      cancelButtonText: `${t('cancel')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.patient.patientUpdate(data);
          if (result.statusCode === 200) {
            if (this.props.contactperson.data.id) {
              await this.props.contactperson.update(this.props.contactperson.data);
            } else {
              await this.props.contactperson.create(this.props.contactperson.data, result.body.id);
            }
            Swal.fire({ html: `<h4>${t('update_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                this.props.patient.setAction('action', true);
                this.props.history.push('../../patients');
              } else {
                Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
              }
            });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else if (e.statusCode === 400) {
            const msg = e.error.message || t('failed_to_update');
            Swal.fire({ html: `<h4>${msg}`, type: 'error' });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
          }
        }
      }
    });
  };

  validate() {
    const { data } = this.state;
    let checkTenant = !data.tenantId ? true : false;
    let checkHn = !data.hn ? true : false;
    let checkFirstname = !data.firstname ? true : false;
    let checkLastname = !data.lastname ? true : false;
    let checkFirstnameEn = !data.firstnameEn ? true : false;
    let checkLastnameEn = !data.lastnameEn ? true : false;
    let checkDob = false;
    let checkContactFirstname = !this.props.contactperson.data.firstname ? true : false;
    let checkContactLastname = !this.props.contactperson.data.lastname ? true : false;
    let checkContactPhone = !this.props.contactperson.data.phone ? true : false;
    let checkContactRelationship = !this.props.contactperson.data.relationship ? true : false;
    let dobErrorReason = '';
    if (data.dob) {
      const date = moment(data.dob, 'YYYY-MM-DD', true);
      const futureDate = moment();
      checkDob = !(date.isValid() && date.isSameOrBefore(futureDate));
      dobErrorReason = checkDob ? errInvalidField : '';
    } else {
      checkDob = true;
      dobErrorReason = errRequired;
    }

    this.setState({
      errorField: {
        tenantId: {
          flag: checkTenant,
          msg: errRequired,
        },
        firstname: {
          flag: checkFirstname,
          msg: errRequired,
        },
        lastname: {
          flag: checkLastname,
          msg: errRequired,
        },
        firstnameEn: {
          flag: checkFirstnameEn,
          msg: errRequired,
        },
        lastnameEn: {
          flag: checkLastnameEn,
          msg: errRequired,
        },
        hn: {
          flag: checkHn,
          msg: errRequired,
        },
        dob: {
          flag: checkDob,
          msg: dobErrorReason,
        },
        contactFirstname: {
          flag: checkContactFirstname,
          msg: errRequired,
        },
        contactLastname: {
          flag: checkContactLastname,
          msg: errRequired,
        },
        contactPhone: {
          flag: checkContactPhone,
          msg: errRequired,
        },
        contactRelationship: {
          flag: checkContactRelationship,
          msg: errRequired,
        },
      },
    });
    return !(
      checkTenant ||
      checkFirstname ||
      checkLastname ||
      checkFirstnameEn ||
      checkLastnameEn ||
      checkHn ||
      checkDob ||
      checkContactFirstname ||
      checkContactLastname ||
      checkContactPhone ||
      checkContactRelationship
    );
  }

  clearErrorField(key) {
    if (key === 'tenantId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          tenantId: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'hn') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          hn: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'firstname') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          firstname: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'lastname') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          lastname: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'firstnameEn') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          firstnameEn: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'lastnameEn') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          lastnameEn: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'dob') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          dob: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'contactFirstname') {
      this.setState({
        errorField: {
          ...this.state.errorField,
          contactFirstname: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'contactLastname') {
      this.setState({
        errorField: {
          ...this.state.errorField,
          contactLastname: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'contactPhone') {
      this.setState({
        errorField: {
          ...this.state.errorField,
          contactPhone: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'contactRelationship') {
      this.setState({
        errorField: {
          ...this.state.errorField,
          contactRelationship: {
            flag: false,
            msg: '',
          },
        },
      });
    }
  }

  renderFormPatient() {
    const { classes, t } = this.props;
    const { data, tenants } = this.state;
    const path = this.props.match.path.replace('/app/patients/:id/', '');
    const { loading } = this.props.patient.toJS();

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          {path === 'edit' ? <PageTitle title={t('edit_a_patient')} /> : <PageTitle title={t('create_a_patient')} />}
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled={path === 'edit' ? true : false}
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}
                  </MenuItem>
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.tenantId.flag : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} md={6} container>
              <Grid item xs={12} sm={2} md={4}>
                <FormInputLabel label={t('first_name_th')} required />
              </Grid>
              <Grid item xs={12} sm={10} md={8} style={{ paddingLeft: 5 }}>
                <TextField
                  required
                  id='firstname'
                  name='firstname'
                  fullWidth
                  value={data.firstname || ''}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.firstname.flag : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.firstname.flag : true}
                  id='component-error-text'
                >
                  {t(`${this.state.errorField.firstname.msg}`)}
                </FormHelperText>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6} container>
              <Grid item xs={12} sm={2} md={4}>
                <FormInputLabel label={t('last_name_th')} required />
              </Grid>
              <Grid item xs={12} sm={10} md={8}>
                <TextField
                  required
                  id='lastname'
                  name='lastname'
                  fullWidth
                  value={data.lastname || ''}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.lastname.flag : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.lastname.flag : true}
                  id='component-error-text'
                >
                  {t(`${this.state.errorField.lastname.msg}`)}
                </FormHelperText>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6} container>
              <Grid item xs={12} sm={2} md={4}>
                <FormInputLabel label={t('first_name_en')} required />
              </Grid>
              <Grid item xs={12} sm={10} md={8} style={{ paddingLeft: 5 }}>
                <TextField
                  required
                  id='firstnameEn'
                  name='firstnameEn'
                  fullWidth
                  value={data.firstnameEn || ''}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.firstnameEn.flag : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.firstnameEn.flag : true}
                  id='component-error-text'
                >
                  {t(`${this.state.errorField.firstnameEn.msg}`)}
                </FormHelperText>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6} container>
              <Grid item xs={12} sm={2} md={4}>
                <FormInputLabel label={t('last_name_en')} required />
              </Grid>
              <Grid item xs={12} sm={10} md={8}>
                <TextField
                  required
                  id='lastnameEn'
                  name='lastnameEn'
                  fullWidth
                  value={data.lastnameEn || ''}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.lastnameEn.flag : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.lastnameEn.flag : true}
                  id='component-error-text'
                >
                  {t(`${this.state.errorField.lastnameEn.msg}`)}
                </FormHelperText>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('hn')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='hn'
                name='hn'
                fullWidth
                value={data.hn || ''}
                onChange={this.handleChange}
                inputProps={{ maxLength: 13 }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[ก-๙]/g, '');
                }}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.hn.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.hn.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.hn.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('birthday')} required />
              <FormInputLabel label='(e.g. 12/11/1990)' />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='date'
                name='dob'
                className={classes.textField}
                fullWidth
                type='date'
                InputLabelProps={{
                  shrink: true,
                }}
                value={data.dob || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.dob.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.dob.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.dob.msg}`)}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('weight')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='weight'
                name='weight'
                value={data.weight || ''}
                onChange={this.validateInputChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                }}
                InputProps={{
                  endAdornment: <InputAdornment position='end'>kg</InputAdornment>,
                }}
                variant='outlined'
                margin='dense'
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('height')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='height'
                name='height'
                value={data.height || ''}
                onChange={this.validateInputChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                }}
                InputProps={{
                  endAdornment: <InputAdornment position='end'>cm</InputAdornment>,
                }}
                variant='outlined'
                margin='dense'
              />
            </Grid>
            <Grid item xs={12} sm={12} container>
              <Grid item xs={12} sm={12} md={6} container>
                <Grid item xs={12} sm={2} md={4}>
                  <FormInputLabel label={t('gender')} required />
                </Grid>
                <Grid item xs={12} sm={10} md={8}>
                  <FormControl component='fieldset' className={`${classes.formControl} genderControl`}>
                    <RadioGroup
                      required
                      // aria-label="Gender"
                      id='gender'
                      name='gender'
                      className={classes.group}
                      value={data.gender || ''}
                      onChange={this.handleChange}
                    >
                      <FormControlLabel value={'M'} control={<Radio id='Male' />} label={t('male')} />
                      <FormControlLabel value={'F'} control={<Radio id='Female' />} label={t('female')} />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} container>
                <Grid item xs={12} sm={2} md={4}>
                  <FormInputLabel label={t('blood_group')} />
                </Grid>
                <Grid item xs={12} sm={10} md={8}>
                  <FormControl className={classes.formControl}>
                    <NativeSelect
                      value={data.bloodGroup || ''}
                      input={
                        <OutlinedInput
                          labelWidth={this.state.labelGroupWidth}
                          name='bloodGroup'
                          id='outlined-group'
                          margin='dense'
                        />
                      }
                      onChange={this.handleChange}
                      margin='dense'
                    >
                      <option value=''></option>
                      {bloodGroupList.map((val) => (
                        <option value={val} key={val}>
                          {val}
                        </option>
                      ))}
                    </NativeSelect>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Divider className={classes.hr} />

            <Grid item xs={12} sm={12} style={{ paddingTop: 40, paddingBottom: 20 }}>
              <InputLabel className={classes.contactLabel}>{t('contact_info_tooltip')}</InputLabel>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('first_name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='contactFirstname'
                name='contactFirstname'
                value={this.props.contactperson.data.firstname || ''}
                onChange={(e) => this.onTextChange('firstname', e)}
                variant='outlined'
                margin='dense'
                fullWidth
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.contactFirstname.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.contactFirstname.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('last_name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='contactLastname'
                name='contactLastname'
                value={this.props.contactperson.data.lastname || ''}
                onChange={(e) => this.onTextChange('lastname', e)}
                variant='outlined'
                margin='dense'
                fullWidth
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.contactLastname.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.contactLastname.msg}`)}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tel')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='contactPhone'
                name='contactPhone'
                value={this.props.contactperson.data.phone || ''}
                onChange={(e) => this.onTextChange('phone', e)}
                inputProps={{ maxLength: 10 }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                }}
                variant='outlined'
                margin='dense'
                fullWidth
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.contactPhone.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.contactPhone.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('relationship')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='contact_relationship'
                name='contactRelationship'
                select
                value={this.props.contactperson.data.relationship || ''}
                onChange={(e) => this.onTextChange('relationship', e)}
                SelectProps={{
                  native: true,
                }}
                variant='outlined'
                margin='dense'
                fullWidth
              >
                <option value=''></option>
                {relationshipList.map((val) => (
                  <option key={val} value={val}>
                    {t(val)}
                  </option>
                ))}
              </TextField>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.contactRelationship.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.contactRelationship.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.onSubmitFormPatient(data)}
                  className={classes.button}
                >
                  {path === 'edit' ? `${t('edit')}` : `${t('create')}`}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { classes, t } = this.props;
    const { data, tenants } = this.state;

    return (
      <React.Fragment>
        <Loader loading={this.state.loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_patient')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled
                >
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={6} container>
              <Grid item xs={12} sm={2} md={4}>
                <FormInputLabel label={t('first_name_th')} required />
              </Grid>
              <Grid item xs={12} sm={10} md={8} style={{ paddingLeft: 5 }}>
                <TextField
                  required
                  id='firstname_'
                  name='firstname'
                  fullWidth
                  value={data.firstname || ''}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} container>
              <Grid item xs={12} sm={2} md={4}>
                <FormInputLabel label={t('last_name_th')} required />
              </Grid>
              <Grid item xs={12} sm={10} md={8}>
                <TextField
                  required
                  id='lastname'
                  name='lastname'
                  fullWidth
                  value={data.lastname || ''}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} container>
              <Grid item xs={12} sm={2} md={4}>
                <FormInputLabel label={t('first_name_en')} required />
              </Grid>
              <Grid item xs={12} sm={10} md={8} style={{ paddingLeft: 5 }}>
                <TextField
                  required
                  id='firstnameEn'
                  name='firstnameEn'
                  fullWidth
                  value={data.firstnameEn || ''}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} container>
              <Grid item xs={12} sm={2} md={4}>
                <FormInputLabel label={t('last_name_en')} required />
              </Grid>
              <Grid item xs={12} sm={10} md={8}>
                <TextField
                  required
                  id='lastnameEn'
                  name='lastnameEn'
                  fullWidth
                  value={data.lastnameEn || ''}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('hn')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='hn'
                name='hn'
                fullWidth
                value={data.hn || ''}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('birthday')} required />
              <FormInputLabel label={t('eg_ad')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='date'
                name='dob'
                fullWidth
                type='date'
                InputLabelProps={{
                  shrink: true,
                }}
                value={data.dob || ''}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('weight')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='weight'
                name='weight'
                value={data.weight || ''}
                variant='outlined'
                margin='dense'
                InputProps={{
                  endAdornment: <InputAdornment position='end'>{t('kg')}</InputAdornment>,
                }}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('height')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='height'
                name='height'
                value={data.height || ''}
                variant='outlined'
                margin='dense'
                InputProps={{
                  endAdornment: <InputAdornment position='end'>{t('cm')}</InputAdornment>,
                }}
                disabled
              />
            </Grid>
            {/* <Grid item xs={12} sm={2} style={{ paddingTop: 25 }}>
              <FormInputLabel label={t('gender')} required />
            </Grid> */}

            <Grid item xs={12} sm={12} container>
              <Grid item xs={12} sm={12} md={6} container>
                <Grid item xs={12} sm={2} md={4}>
                  <FormInputLabel label={t('gender')} required />
                </Grid>
                <Grid item xs={12} sm={10} md={8}>
                  <FormControl component='fieldset' className={`${classes.formControl} genderControl`}>
                    <RadioGroup
                      required
                      aria-label='Gender'
                      id='gender'
                      name='gender'
                      className={classes.group}
                      value={data.gender || 'M'}
                      onChange={this.handleChange}
                    >
                      <FormControlLabel value={'M'} control={<Radio id='Male' />} label={t('male')} disabled />
                      <FormControlLabel value={'F'} control={<Radio id='Female' />} label={t('female')} disabled />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} container>
                <Grid item xs={12} sm={2} md={4}>
                  <FormInputLabel label={t('blood_group')} />
                </Grid>
                <Grid item xs={12} sm={10} md={8}>
                  <FormControl className={classes.formControl}>
                    <NativeSelect
                      value={data.bloodGroup || ''}
                      input={
                        <OutlinedInput
                          labelWidth={this.state.labelGroupWidth}
                          name='bloodGroup'
                          id='outlined-group'
                          margin='dense'
                        />
                      }
                      onChange={this.handleChange}
                      margin='dense'
                      disabled
                    >
                      <option value=''></option>
                      {bloodGroupList.map((val) => (
                        <option value={val} key={val}>
                          {val}
                        </option>
                      ))}
                    </NativeSelect>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Divider className={classes.hr} />

            <Grid item xs={12} sm={12} style={{ paddingTop: 40, paddingBottom: 20 }}>
              <InputLabel className={classes.contactLabel}>{t('contact_info')}</InputLabel>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('first_name')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='contactFirstname'
                name='contactFirstname'
                value={data.contactFirstname || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                fullWidth
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('last_name')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='contactLastname'
                name='contactLastname'
                value={data.contactLastname || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tel')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='contactPhone'
                name='contactPhone'
                value={data.contactPhone || ''}
                onChange={this.handleChange}
                inputProps={{ maxLength: 10 }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                }}
                variant='outlined'
                margin='dense'
                fullWidth
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('relationship')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                select
                id='contact_relationship'
                name='contactRelationship'
                value={data.contactRelationship || ''}
                onChange={this.handleChange}
                SelectProps={{
                  native: true,
                }}
                variant='outlined'
                margin='dense'
                fullWidth
                disabled
              >
                <option value=''></option>
                {relationshipList.map((val) => (
                  <option key={val} value={val}>
                    {t(val)}
                  </option>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/patients/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormPatient();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderFormPatient();
        break;
    }
    return result;
  }
}

const styles = (theme) => ({
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  // formControl: {
  //   width: '100%',
  // },
  group: {
    display: 'block',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: '100%',
  },
  hr: {
    width: '100%',
  },
  contactLabel: {
    color: '#009688',
    fontWeight: 400,
    fontSize: '20px',
    paddingBottom: '20px',
  },
});
export const page = inject('patient', 'setting', 'contactperson')(observer(PatientsPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
